import { Typography } from '@mui/material';
import EmptyStateCat from 'assets/icons/empty-state-cat.svg';

import { EmptyStateProps } from './types';

import * as S from './styles';

export function EmptyState({ text, image }: EmptyStateProps) {
  return (
    <S.Wrapper>
      <S.Icon>{image || <EmptyStateCat />}</S.Icon>
      <Typography variant="body1">{text}</Typography>
    </S.Wrapper>
  );
}
